<mat-label class="subHeading">Payin Type</mat-label>
<mat-select formControlName="payin_type" placeholder="All">
    <mat-option value="percentage">Percentage</mat-option>
    <mat-option value="flat">Flat Amount</mat-option>
</mat-select>